// components/Popup.js
import React from 'react';
import './Popup.css'; // style as needed

const Popup = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="popup-close" onClick={onClose}>×</button>
        {children}
      </div>
    </div>
  );
};

export default Popup;
